import { BDSMForm } from '../../../../../components/form/BDSMForm';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

export const DayPeopleForm = ({ onClick, day }) => {

    const { t } = useTranslation('monthMenu');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getInitValues = () => {
        return {
            littleOnes: day.predictedLittleOnes,
            olderKids: day.predictedOlderKids,
            preschoolers: day.predictedPreschoolers,
            workers: day.predictedWorkers,
        };
    };

    const validation = Yup.object().shape({
        olderKids: Yup.string().required(t('validations:required')),
        littleOnes: Yup.string().required(t('validations:required')),
        preschoolers: Yup.string().required(t('validations:required')),
        workers: Yup.string().required(t('validations:required')),
    });

    const handleSubmit = (values) => {
        let request = { ...values, dayOfMenu: day.dayNumber };
        onClick(request);
        onClose();
    };

    const onClose = () => {
        handleClose();
    };

    const getFormModel = () => {
        return {
            initValues: getInitValues(),
            onSubmit: (record) => handleSubmit(record),
            onCancel: () => onClose(),
            validationSchema: validation,
            fieldNames: ['littleOnes', 'olderKids', 'preschoolers', 'workers'],
            types: ['number', 'number', 'number', 'number'],
            className: 'mb-3',
            label: [t('littleOnes'), t('olderKids'), t('preschoolers'), t('workers')],
            selectData: [null, null, null, null],
            inputFieldsClass: '',
            hideCancel: true,
        };
    };

    return (
        <>
            <button className={'button--main success-button'}
                    id={'predict-people' + day.dayNumber}
                    onClick={handleShow}>
                {t('predict')}
            </button>
            <Modal show={show} onHide={onClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{day.dayNumber} {t('dayNumber')}. {t('predictedPeople')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BDSMForm form={getFormModel()}></BDSMForm>
                </Modal.Body>
            </Modal>
        </>
    );
};